import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import ShieldIcon from '@mui/icons-material/Shield';

import axios from "axios";
import { useNavigate } from "react-router-dom";
import * as constants from "./constants.js"
import avatarImage from './img/JKU_School_BUS_en_schwarz_hoch_rgb.png';

const pages = [];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [isAdmin, setIsAdmin] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    (async () => {
      try {
        const resp = await axios.create({ withCredentials: true }).get("//" + constants.BASE_URL + "/@me");
        setIsAdmin(resp.data.admin === true);
      } catch (error) {}
    })();
  }, []);

  const logoutUser = async () => {
    await axios.create({
        withCredentials: true,
      }).post("//" + constants.BASE_URL + "/logout");
    navigate('/login');
  };

  const navToUserPreferences = async () => {
    navigate('/user/preferences');
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (event) => {
    setAnchorElUser(null);
    const text = event.target.textContent;
    if(text === 'Logout'){
      logoutUser();
    }else if(text === 'Einstellungen'){
      navToUserPreferences();
    }else if(text === 'Benutzerverwaltung'){
      navigate('/admin-users');
    }else if(text === 'Admin-Parameter'){
      navigate('/admin-parameters');
    }else if(text === 'Berechnungswarteschlange'){
      navigate('/computation-queue-manager');
    }else if(text === 'Gesamtübersicht'){
      navigate('/admin-overview');
    }
  };

  return (
    <AppBar position="static" disableGutters sx={{ bgcolor: '#5dade2' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ bgcolor: '#5dade2' }}>
          <ShieldIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          {/* <Box
            component="img"
            src={avatarImage}
            alt="Logo"
            sx={{
              display: { xs: 'none', md: 'flex' },
              mr: 1,
              mt: 3,
              height: 62, // Adjust the size as needed
              width: 75,  // Adjust the size as needed
            }}
          /> */}
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Rapid Resilience
          </Typography>

          <ShieldIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar src="/static/img/user.jpeg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography textAlign="center">Einstellungen</Typography>
              </MenuItem>
              {isAdmin && (
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">Benutzerverwaltung</Typography>
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">Admin-Parameter</Typography>
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">Berechnungswarteschlange</Typography>
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">Gesamtübersicht</Typography>
                </MenuItem>
              )}
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography textAlign="center">Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;